import { useEffect, useState } from "react";
import { db } from "../firebase_conf";
import { doc, getDocs, query, where, collection } from "firebase/firestore";

const PrintReport = (props) => {
  const queryParameters = new URLSearchParams(window.location.search);
  const id = queryParameters.get("id");
  const [data, setData] = useState({});
  useEffect(() => {
    document.body.style.color = "black";
    document.body.style.background = "white";
    const getData = async (id) => {
      const docReports = collection(db, "admin_reports");

      const q = query(docReports, where("incident_id", "==", id));
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        console.log(doc.id, " => ", doc.data());
        setData(doc.data());
      });
    };

    getData(id);
  }, [id]);

  useEffect(() => {
    if (Object.entries(data).length !== 0) {
      window.print()
    }
  }, [data]);

  return (
    <>
      <div
        style={{
          width: "100%",
          textAlign: "center",
        }}
      >
        <div style={{display:'inline-flex', gap:'50px', margin:'auto'}}>
          <div><img src="/paracale_logo.jpg" alt="Logo" width={50} style={{marginTop:"15px"}}></img></div>
          <div style={{marginBottom:"13px"}}>
            <p style={{margin:0}}>Republic of the Philippines</p>
            <p style={{margin:0}}>Province of Camarines Norte</p>
            <p style={{margin:0}}>Municipality of Paracale</p>
          </div>
          <div><img src="/paracale_logo_1.jpg" alt="Logo" width={55} style={{marginTop:"15px"}}></img></div>
        </div>
        <h3 style={{ margin: 0 }}>
          MUNICIPAL DISASTER RISK REDUCTION AND MANAGEMENT OFFICE
        </h3>
        <h4 style={{ margin: 0 }}>Operation Center</h4>
        <h3>RESCUE OPERATIONS REPORT</h3>
        <p style={{ textAlign: "right", paddingRight: "20px" }}>Date: {new Date(data.timestamp&&data.timestamp.seconds*1000).toLocaleDateString()}</p>
      </div>
      <table
        style={{
          border: "1px solid",
          width: "100%",
          borderCollapse: "collapse",
          padding: "5px",
        }}
      >
        <tbody>
          <tr>
            <td style={{ padding: "5px", border: "1px solid" }} colSpan={3}>
              <b>Incident: </b>
              {data.incident_description}
            </td>
          </tr>
          <tr>
            <td style={{ padding: "5px", border: "1px solid" }}>
              <b>Time of Departure from the office: </b>
              {data.time_departure_from_office}
            </td>
            <td style={{ padding: "5px", border: "1px solid" }} colSpan={2}>
              <b>Time of Departure from the Incident: </b>
              {data.time_departure_from_incident}
            </td>
          </tr>
          <tr>
            <td style={{ padding: "5px", border: "1px solid" }}>
              <b>Time of Arrival to the Incident: </b>
              {data.time_arrival_to_the_incident}
            </td>
            <td style={{ padding: "5px", border: "1px solid" }} colSpan={2}>
              <b>Time of Arrival back to the Office/Garage: </b>
              {data.time_arrival_to_the_office}
            </td>
          </tr>
          <tr>
            <td style={{ padding: "5px", border: "1px solid" }} colSpan={3}>
              <b>Patient's Information:</b>
            </td>
          </tr>
          <tr>
            <td style={{ padding: "5px", border: "1px solid" }} colSpan={3}>
              <b>Name: </b>
              {data.name}
            </td>
          </tr>
          <tr>
            <td style={{ padding: "5px", border: "1px solid" }} colSpan={3}>
              <b>Address: </b>
              {data.address}
            </td>
          </tr>
          <tr>
            <td style={{ padding: "5px", border: "1px solid" }} colSpan={3}>
              <b>Gender: </b>
              {data.gender}
            </td>
          </tr>
          <tr>
            <td style={{ padding: "5px", border: "1px solid" }} colSpan={3}>
              <b>Condition of Patient's: </b>
              {data["condition_of_patient(s)"]}
            </td>
          </tr>
          <tr>
            <td style={{ padding: "5px", border: "1px solid" }} colSpan={3}>
              <b>Treatment Applied: </b>
              {data.treatment_applied}
            </td>
          </tr>
          <tr>
            <td style={{ padding: "5px", border: "1px solid" }} colSpan={3}>
              <b>Informant:</b>
            </td>
          </tr>
          <tr>
            <td style={{ padding: "5px", border: "1px solid" }}>
              <b>Contact Person: </b>
              {data.contact_person}
            </td>
            <td style={{ padding: "5px", border: "1px solid" }}>
              <b>Contact#: </b>
              {data.contact_number}
            </td>
            <td style={{ padding: "5px", border: "1px solid" }}>
              <b>Relationship: </b>
              {data.relationship}
            </td>
          </tr>
          <tr>
            <td style={{ padding: "5px", border: "1px solid" }} colSpan={3}>
              <b>Location of the Incident: </b>
              {data.location_of_the_incident}
            </td>
          </tr>
          <tr>
            <td style={{ padding: "5px", border: "1px solid" }} colSpan={3}>
              <b>Responders: </b>
              {data.responders}
            </td>
          </tr>
          <tr>
            <td style={{ padding: "5px", border: "1px solid" }} colSpan={2}>
              <b>Driver: </b>
              {data.responders}
            </td>
            <td style={{ padding: "5px", border: "1px solid" }}>
              <b>Signature:</b>
            </td>
          </tr>
          <tr>
            <td style={{ padding: "5px", border: "1px solid" }} colSpan={3}>
              <b>Referred to: </b>
              {data.referred_to}
            </td>
          </tr>
          <tr>
            <td style={{ padding: "5px", border: "1px solid" }} colSpan={3}>
              <b>Vehicle used: </b>
              {data.vehicle_used}
            </td>
          </tr>
        </tbody>
      </table>
      <div
        style={{ textAlign: "center", marginTop: "10px", fontWeight: "500px" }}
      >
        I HEREBY CERTIFY to the correctness of the statements and record of the
        operation state above.
      </div>
      <div style={{width:"100%"}}>
        <div style={{ marginLeft:"auto", width:"300px", textAlign:"center"}}>
          <p>____________________________</p>
          <p>Team Leader Signature</p>
        </div>
      </div>
    </>
  );
};

export default PrintReport;
